import { ref, onMounted, onUnmounted } from 'vue';
import { throttle } from 'lodash';

export function useFullScreenTableHeight(minus?: number) {
    const tableHeight = ref<number>(0);
    const updateTableHeight = () => {
        let height = 0;
        let initMinus = 0;


        const tableTopSectionDom: any = document.querySelector(".drawer-make-table-fullscreen.crm-table") //角色与权限管理--查看成员
            || document.querySelector(".make-table-fullscreen.crm-table")
            || document.querySelector(".make-table-fullscreen .crm-table");

        //获取table距离顶部的高度
        if (tableTopSectionDom) {
            height = tableTopSectionDom.getBoundingClientRect().top + 74;
            initMinus = minus || height;
            tableHeight.value = window.innerHeight - initMinus;
        }

        // 特殊定制：若直接父元素包含 'no-fullscreen-table' 类，则给的固定高度（关联联系人及关联商机弹窗table）
        const tableElements = document.querySelectorAll('.no-fullscreen-table .crm-table[show-summary="false"]');
        tableElements && tableElements.forEach(element => {
            if (element.parentElement.classList.contains('no-fullscreen-table')) {
                tableHeight.value = 300;
            }
        });

        // 特殊定制，数据分析中的table
        const analysisTableDomList = document.querySelectorAll(".make-table-analysis-fullscreen");
        if (analysisTableDomList[0]) {
            analysisTableDomList.forEach((table, index) => {
                if (getComputedStyle(table).display !== 'none') {
                    initMinus = analysisTableDomList[index].getBoundingClientRect().top + 74;
                    tableHeight.value = window.innerHeight - initMinus;
                }
            })
        }
    }
    //节流：函数被调用后立即执行，随后1000毫秒内多次触发，只执行一次；
    const throttleUpdateTableHeight = throttle(updateTableHeight, 1000);
    onMounted(() => {
        throttleUpdateTableHeight();
        window.addEventListener('resize', throttleUpdateTableHeight);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', throttleUpdateTableHeight);
    });
    return { tableHeight };
}

